<div (click)="this.maybeOpenDateTimePopover($event)">
  <ion-input *ngIf="withTime; else withoutTime" [value]="value | dateTimezone: 'short'" disabled></ion-input>
  <ng-template #withoutTime>
    <!-- date without time, entered by user, do not use pipe dateTimezone -->
    <ion-input [value]="value | date: 'shortDate'" disabled></ion-input>
  </ng-template>
  <ion-icon class="calendar-icon" name="calendar-outline"></ion-icon>
</div>
<span *ngIf="value && !disabled">
  <!-- classes are used to reproduce the apparence of the clear button in a ion-input -->
  <button aria-label="reset" type="button" class="input-clear-icon sc-ion-input-md" (click)="clear()">
    <ion-icon class="sc-ion-input-md" name="close"></ion-icon>
  </button>
</span>
